export default [
    {
      path: '/mi-perfil',
      name: 'assistant-profile',
      component: () => import('../views/assistant/Profile.vue'),
      meta: {
        title: 'Perfil de usuario',
      },
    },
    {
      path: '/mis-eventos',
      name: 'assistant-events',
      component: () => import('../views/assistant/MyEvents.vue'),
      meta: {
        title: 'Mis eventos',
      },
    },
    {
      path: '/mis-afiliaciones',
      name: 'assistant-plans',
      component: () => import('../views/assistant/MyPlans.vue'),
      meta: {
        title: 'Mis afiliaciones',
      },
    },
    {
      path: '/metodos-de-pago',
      name: 'assistant-payment-methods',
      component: () => import('../views/assistant/PaymentMethod.vue'),
      meta: {
        title: 'Métodos de pago',
      },
    },
  ]